import React from 'react'
import Lottie from 'react-lottie';

import name from '../assets/lotties/NAME.json';


export default function Header() {
    return (
        <div className='header-container'>
            <div className='logo-container'>
                <a href="/#/">
                    <Lottie
                        options={{
                            loop: true,
                            autplay: true,
                            animationData: name,
                            rendererSettings: {
                                preserveAspectRatio: 'xMidYMid slice'
                            }
                        }}
                        height={40}
                        width={200}
                    />
                </a>
            </div>
            <div className='links-container'>
                <a className='link-home' href="/#" >HOME</a>
                <a className='link-works' href="/#/works" >WORKS</a>
            </div>
        </div>
    )
}


/**
 * 
 *   <Lottie
                    options={{
                        loop: true,
                        autplay: true,
                        animationData: name,
                        rendererSettings: {
                            preserveAspectRatio: 'xMidYMid slice'
                        }
                    }}
                    height={400}
                    width={400}
                />
 * 
 */